import CryptoJS from 'crypto-js';
import { getAuthenticationType, AuthenticationType } from "../../constants/AuthenticationType"
import { setAuthToken } from "../../helpers/storage";

/**
 * Obsługa autentyfikacji w zależności od wybranego typu autoryzacji
 * 
 * W przypadku JWT - dostajemy token
 * 
 * W przypadku BASIC i HMAC - dostajemy uzytkownika
 * 
 * @param { String | Object} authenticationResult - token otrzymany z serwera
 * @param {UserCredentials } userCredentials - obiekt danych do uwierzytelnienia (email, passowrd)
 */
export const handleAuthentication = (authenticationResult, userCredentials) => {

    //pobieramy ustawiony typ autentyfikacji
    let authenticationType = getAuthenticationType();

    switch (authenticationType) {
        case AuthenticationType.JWT:
            //w przypadku jwt - zapisujemy token do storage
            //zapisujemy token do storage
            setAuthToken(authenticationResult);
            break;
        case AuthenticationType.HMAC:
            //w przypadku hmac - nie zapisujemy tokena, wylicza się dla każdego requestu indywidulanie
            break;

        case AuthenticationType.BASIC:
            //w przypadku basic - zapisujemy token do storage
            //zapisujemy token do storage

            // Encode in classical base64
            const source = `${userCredentials.email}:${userCredentials.password}`
            var wordArray = CryptoJS.enc.Utf8.parse(source);
            var base64 = CryptoJS.enc.Base64.stringify(wordArray);

            setAuthToken(base64);
            break;
        default:
            console.error('No autentication type selected');
    }

}